import { ApiBucketResponse, ApiProject } from "@incendium/api";
import { trafficBucketService } from "Apis";
import { useProjectSharedState } from "./useSharedState";
import { ApiAttributionTagReserved } from "@incendium/api";
import { useMemo } from "react";

const fetchTrafficBuckets = async (project: ApiProject) => {
  const buckets = await trafficBucketService.bucketServiceListBuckets({
    projectId: project.id as number,
  });
  return buckets.results || [];
};

export const useTrafficBuckets = () => {
  const { state, setState, loading } = useProjectSharedState<ApiBucketResponse[]>(
    "buckets",
    [],
    fetchTrafficBuckets
  );

  const rOIBuckets = useMemo(() => {
    return [
      ApiAttributionTagReserved.AWARENESS,
      ApiAttributionTagReserved.ACQUISITION,
      ApiAttributionTagReserved.RETENTION,
    ]
      .map((key) => ({
        name: key,
        bucketNames: state
          .filter(
            (b) => (b.tags || []).findIndex((t) => t.reserved === key) >= 0
          )
          .map((d) => d.name || ""),
      }))
      .filter((d) => d.bucketNames.length > 0);
  }, [state]);

  return {
    trafficBuckets: state,
    setTrafficBuckets: setState,
    loading,
    rOIBuckets,
  };
};
